export enum AccountRoutesPathEnum {
    ACTIONS = '/actions/',
    WITHDRAWAL = '/withdrawal/',
    BILLING_INFO = '/billing-info/',
    PAYOUTS = '/payouts/',
    PROMO = '/promo-codes/',
    REFERRAL_PROGRAM = '/referral/',
}
